import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/especiais/biofresh/page.client.tsx");
